import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { apiEndpoints } from '../constants/api-endpoints';
import { HttpUtilityService } from './http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class UserFormAddItemService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  updateItem(
    itemId: number,
    formData: FormData
  ): Observable<HttpResponse<string>> {
    const url = `${apiEndpoints.updateUserItem}?itemId=${itemId}`;
    return this.httpUtilityService.post<string>(url, formData);
  }

  getItemDetails(itemId: number): Observable<HttpResponse<any>> {
    const url = `${apiEndpoints.getItemDetails}/${itemId}`;
    return this.httpUtilityService.get<any>(url);
  }

  saveItem(formData: FormData, type: string): Observable<HttpResponse<string>> {
    const url = `${apiEndpoints.userItem}/${type}`;
    return this.httpUtilityService.post<string>(url, formData, 'text');
  }
  getUom(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.uomList);
  }

  getPriority(): Observable<HttpResponse<any[]>> {
    return this.httpUtilityService.get<any[]>(apiEndpoints.prioritylist);
  }

  deleteAttachment(attachId: number, isTemp: boolean): Observable<any> {
    let url = `${apiEndpoints.deleteAttachment}${attachId}?isTemp=${isTemp}`;
    return this.httpUtilityService.delete<any>(url);
  }

  getAttachments(
    tableData: string,
    pnaNo: string,
    pnaYear: number,
    itemNo: string
  ): Observable<any> {
    return this.httpUtilityService.getByParam<any>(
      apiEndpoints.getAttachmentsDetails,
      {
        tableData,
        pnaNo,
        pnaYear: pnaYear.toString(),
        itemNo,
      }
    );
  }
}
